import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { connect } from 'react-redux';
import Spinner from '../Widgets/spinner';
import ContentWrapper from '../Layout/ContentWrapper';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../actions/root_url';

const isChinaTown = ROOT_API_URL === 'https://erp.chinatown-supermarket.com/api/' || ROOT_URL === 'https://erp.chinatown-supermarket.com/api/';

class ItemHistoryGrid extends Component {
  constructor() {
    super();

    this.state = {
      itemHistory: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
      },
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.salesItemHistory && nextProps.salesItemHistory !== this.props.salesItemHistory) {
      let name = '';
      if (nextProps.salesItemHistory[0]) {
        name = nextProps.salesItemHistory[0].Name;
      }
      const historyRows = [...nextProps.salesItemHistory];
      historyRows.map(row => {
        row.Date = String(row.Date).substring(0, 10);
      });
      const itemHistory = { ...this.state.itemHistory, rows: historyRows };
      this.setState({ itemHistory, productHistoryLabel: name });
    }
  }

  render() {
    // if (this.props.salesItemHistoryIsLoading && !this.props.salesItemHistoryError) return <Spinner/>
    // else if (this.props.salesItemHistoryError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.salesItemHistoryError)}</div></ContentWrapper>
    // else {
      const getRows = () => {
        return Data.Selectors.getRows(this.state.itemHistory);
      };

      const getSize = () => {
        return getRows().length;
      };

      const rowGetter = rowIdx => {
        var rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        var itemHistory = { ...this.state.itemHistory, sortColumn: sortColumn, sortDirection: sortDirection };
        this.setState({ itemHistory });
      }

      return (
        <Row>
          <Col xs={12}>
            <div className="react-table-customizer" id="ItemHistoryGrid-dataGrid1" style={{marginBottom: isChinaTown ? '10px' : '0'}}>
              <ReactDataGrid
                onGridSort={handleGridSort}
                columns={this.props.columns}
                rowHeight={25}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                enableRowSelect={this.props.enableRowSelect}
                minHeight={this.props.minHeight}
                onRowUpdated={this.props.handleRowUpdated}
                onRowClick={this.props.onRowClick}
                rowSelection={this.props.rowSelection}
              />
            </div>
          </Col>
        </Row>
      );
    // }
  }
}

function mapStateToProps(state) {
  return {
    salesItemHistory: state.salesOrders.salesItemHistory,
    salesItemHistoryIsLoading: state.salesOrders.salesItemHistoryIsLoading,
    salesItemHistoryError: state.salesOrders.salesItemHistoryError,
  };
}

export default connect(mapStateToProps, {})(ItemHistoryGrid);



// WEBPACK FOOTER //
// ./master/jsx/components/Common/itemHistoryGrid.jsx